import type { FC } from "react";

import _ from "lodash";
import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { OnOffSwitch, PlainTooltip } from "@similarweb/ui-components";

import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";

interface IToggleFilter {
    isActive: boolean;
    onClick?: VoidFunction;
    isDisabled?: boolean;
    label?: string;
    tooltip?: string;
    className?: string;
}

const DEFAULT_CLASS_NAME = "no-margin";

const { carbon } = colorsPalettes;

const Label = styled.label`
    ${setFontVariant("body1", carbon[300])};
`;

const WithLabelContainer = styled(BaseFlex)`
    gap: 12px;
`;

const Container = styled.div<{ isDisabled?: boolean }>`
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    .${DEFAULT_CLASS_NAME} {
        margin: unset;
    }
`;

export const ToggleFilter: FC<IToggleFilter> = (props) => {
    const {
        isActive,
        label,
        tooltip,
        isDisabled,
        onClick: onClickProp = _.noop,
        className = DEFAULT_CLASS_NAME,
    } = props;
    const onClick = () => {
        if (isDisabled) {
            return;
        }
        onClickProp();
    };
    return (
        <Container isDisabled={isDisabled}>
            <PlainTooltip
                tooltipContent={tooltip}
                enabled={Boolean(tooltip)}
            >
                {label ? (
                    <WithLabelContainer onClick={onClick}>
                        <OnOffSwitch
                            isSelected={isActive}
                            isDisabled={isDisabled}
                            className={className}
                        />
                        <Label>{label}</Label>
                    </WithLabelContainer>
                ) : (
                    <OnOffSwitch
                        isSelected={isActive}
                        onClick={onClick}
                        isDisabled={isDisabled}
                        className={className}
                    />
                )}
            </PlainTooltip>
        </Container>
    );
};
